module.exports = __webpack_public_path__ + "img/money-stock.59e5ff46.png";